import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import Actions from 'Actions';
import OrderUtils from 'utils/Order';
import urlUtils from 'utils/Url';
import anaUtils from 'analytics/utils';
import { SMS_NOTIFICATION_STATUS } from 'constants/orderStatus';
import orderDetailsBindings from 'analytics/bindingMethods/pages/orderDetails/orderDetailsBindings';
import { userSelector } from 'selectors/user/userSelector';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';
import BopisSddSmsSignupButtonEN from 'components/RichProfile/MyAccount/BopisSddSmsSignupButton/locales/BopisSddSmsSignupButton_en_US';
import BopisSddSmsSignupButtonFR from 'components/RichProfile/MyAccount/BopisSddSmsSignupButton/locales/BopisSddSmsSignupButton_fr_CA';

const { getOrderDetailsUrl, getOrderId, getOrderShippingMethod, ORDER_DETAILS_REQUESTS_ORIGIN } = OrderUtils;
const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const { showSMSSignupModal } = Actions;
const { redirectTo } = urlUtils;
const getText = getLocalisedDataFromResource(BopisSddSmsSignupButtonEN, BopisSddSmsSignupButtonFR);

const localization = createStructuredSelector({
    getSmsUpdates: getTextFromResource(getText, 'getSmsUpdates'),
    alreadyEnrolled: getTextFromResource(getText, 'alreadyEnrolled'),
    orderDetailsAndSmsUpdates: getTextFromResource(getText, 'orderDetailsAndSmsUpdates')
});

const fields = createSelector(
    localization,
    userSelector,
    orderDetailsSelector,
    (_, ownProps) => ownProps.isCheckout,
    (_, ownProps) => ownProps.smsNotificationFlag,
    (textResources, user, orderDetails, isCheckout, smsNotificationFlag) => {
        const { getSmsUpdates, alreadyEnrolled, orderDetailsAndSmsUpdates } = textResources;
        const isEnrolled = smsNotificationFlag === SMS_NOTIFICATION_STATUS.AVAILABLE_BUT_ENROLLED;
        const isDisabled = isCheckout ? false : isEnrolled;
        const buttonText = isCheckout ? orderDetailsAndSmsUpdates : isEnrolled ? alreadyEnrolled : getSmsUpdates;

        const orderId = getOrderId();
        const isGuestOrder = orderDetails?.header?.isGuestOrder;
        const guestEmail = orderDetails?.header?.guestProfile?.email;
        const userEmail = user?.login;
        const baseOrderDetailsURL = `${getOrderDetailsUrl(orderId)}?requestOrigin=${ORDER_DETAILS_REQUESTS_ORIGIN.ORD_CONFIRMATION_PAGE}`;
        const orderDetailsURL = isGuestOrder && userEmail !== guestEmail ? `${baseOrderDetailsURL}&guestEmail=${guestEmail}` : baseOrderDetailsURL;
        const redirectToOrderDetails = () => {
            anaUtils.setNextPageData({ linkData: 'see order details & get sms updates click' });
            redirectTo(orderDetailsURL);
        };

        return {
            isDisabled,
            buttonText,
            redirectToOrderDetails
        };
    }
);

const functions = dispatch => ({
    openSmsSignupModal: () => {
        orderDetailsBindings.SMSSignupModal({ orderId: getOrderId(), orderShippingMethod: getOrderShippingMethod() });
        const action = showSMSSignupModal({ isOpen: true });
        dispatch(action);
    }
});

const withBopisSddSmsSignupButtonProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, localization, withBopisSddSmsSignupButtonProps
};
